type InitDataParams = {
  appVersion: string
  ucode: string
  userId: number
  userRole: 'OWNER' | 'MODERATOR' | 'ADMIN' | 'CONSUMER'
  isLogged: boolean
  membershipSlug: string
  membershipId: string
}

export class DataHubStore {
  private static instance: DataHubStore

  private appVersion = '1.0'
  private ucode = ''
  private membershipSlug = ''
  private userId: number | null = null
  private userRole = ''
  private isLogged = false
  private membershipId = ''

  private static getInstance() {
    if (!DataHubStore.instance) {
      DataHubStore.instance = new DataHubStore()
    }

    return DataHubStore.instance
  }

  static initData({
    appVersion,
    ucode,
    userId,
    userRole,
    isLogged,
    membershipSlug,
    membershipId
  }: InitDataParams) {
    this.getInstance().appVersion = appVersion
    this.getInstance().ucode = ucode
    this.getInstance().userId = userId
    this.getInstance().userRole = userRole
    this.getInstance().isLogged = isLogged
    this.getInstance().membershipSlug = membershipSlug
    this.getInstance().membershipId = membershipId
  }

  static resetData() {
    this.getInstance().appVersion = ''
    this.getInstance().ucode = 'X'
    this.getInstance().userId = 0
    this.getInstance().userRole = ''
    this.getInstance().membershipSlug = ''
    this.getInstance().membershipId = ''
  }

  static getAppVersion() {
    return this.getInstance().appVersion
  }

  static getUcode() {
    return this.getInstance().ucode
  }

  static getUserId() {
    return this.getInstance().userId as number
  }

  static getUserRole() {
    return this.getInstance().userRole
  }

  static getIsLogged() {
    return this.getInstance().isLogged
  }

  static getMembershipSlug() {
    return this.getInstance().membershipSlug
  }

  static getMembershipId() {
    return this.getInstance().membershipId
  }
}
